"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pageName: 'taskScheduleLog',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        taskSchedulerJobPk: '',
        taskJobName: '',
        result: '',
        startTime: '',
        endTime: ''
      },
      jobList: []
    };
  },
  mounted: function mounted() {
    this.getJobList();
  },
  methods: {
    getJobList: function getJobList() {
      var _this = this;
      this.$api.taskScheduleLog.getTaskScheduleLogJobList().then(function (res) {
        _this.jobList = res.data;
      });
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          taskJobName: this.searchVal.taskJobName,
          taskSchedulerJobPk: this.searchVal.taskSchedulerJobPk,
          result: this.searchVal.result,
          startTime: this.searchVal.startTime,
          endTime: this.searchVal.endTime
        }
      };
      this.listLoading = true;
      this.$api.taskScheduleLog.getTaskScheduleLogList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    resetData: function resetData() {
      this.searchVal = {
        taskSchedulerJobPk: '',
        taskJobName: '',
        result: '',
        startTime: '',
        endTime: ''
      };
      this.fetchData();
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    execute: function execute(row) {
      var _this3 = this;
      this.$api.taskScheduleLog.executeTask(row.taskSchedulerJobPk).then(function (res) {
        _this3.$message.success(_this3.$t('taskScheduleLog.message.success'));
      }).catch(function (res) {
        _this3.$message.error(_this3.$t('taskScheduleLog.message.error'));
      });
    }
  }
};